// extracted by mini-css-extract-plugin
module.exports = {"sliderArrow":"styles-module--sliderArrow--Px0sO","left":"styles-module--left--2QsI6"};